<template>
  <div class="pagePagination">
    <span class="total">总共{{listTotal}}条  显示{{((pageNo - 1) * form.size) + 1}}-{{(pageNo) * form.size}}条</span>
    <div class="pagination">
      <el-pagination
              background
              small
              :current-page="pageNo"
              :page-size="form.size"
              layout="prev, pager, next"
              :total="listTotal"
              @current-change="changePage">
      </el-pagination>
<!--      <el-select v-model="form.size" placeholder="请选择" size="small" class="form.size" @change="changeSize">-->
<!--        <el-option label="10条/页" value="10"></el-option>-->
<!--        <el-option label="20条/页" value="20"></el-option>-->
<!--        <el-option label="30条/页" value="30"></el-option>-->
<!--      </el-select>-->

<!--      <div class="current">跳转至第<el-input v-model="form.page" size="small" @change="changeInput"></el-input>页</div>-->
    </div>
  </div>
</template>

<script>
  export default {
  name: 'listPagination',
  data () {
    return {
      form: {
        size: 0,
        page: this.pageNo,
        pageSize:10
      },
    }
  },
  props: {
    pageNo: Number,
    listTotal: Number
  },
  watch: {
    pageNo () {
      this.form.page = this.pageNo
    }
  },
  created() {
   // this.form.size = window.config.pageSize
    this.form.size =  this.form.pageSize
  },
  methods: {
    changePage (val) {
      this.$emit('changeListPage', val)
    },
    //
    // changeSize (val) {
    //   this.$emit('changeListSize', val)
    // },

    changeInput (val) {
      let pageSize = (this.listTotal % this.form.size) > 0 ? parseInt(this.listTotal / this.form.size) + 1 : parseInt(this.listTotal / this.form.size)
      if (Number(val) > pageSize) {
        this.form.page = this.pageNo
        return false
      }
      this.$emit('changeListPage', val)
    }
  }
}
</script>
